import React, { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { Route, Routes, useLocation } from 'react-router-dom'
import ConfirmPage from '../components/views/CDPRequestConfirmPage'
import SuccessPage from '../components/views/CDPSuccessPage'
import { CDP_PUBLIC_URL, IDLE_TIMEOUT } from '../utils/Constants'
import { adobeAnalyticsScriptAddition, getExitPath, loadSatelliteScript, sessionUtils, cssAddition } from '../utils/Utils'
import Footer from './layout/Footer'
import FormContainer from './layout/FormContainer'
import Header from './layout/Header'
import ConsultationComplete from './views/ConsultationComplete'
import ConsultationServiceConfirmPage from './views/ConsultationConfirmPage'
import ConsultationServiceForm1 from './views/ConsultationForm'
import DairitenConfirmPage from './views/DairitenConfirmPage'
import DairitenFormPage from './views/DairitenForm'
import DairitenThankYou from './views/DairitenThankYou'
import ToiawaseFormPage from './views/Toiawase'
import ToiawaseFormConfirmPage from './views/ToiawaseFormConfirmPage'
import ToiawaseThankYou from './views/ToiawaseThankyou'
import PamphletRequestForm from './views/PamphletRequestForm'
import PamphletRequestConfirm from './views/PamphletRequestConfirm'
import PamphletRequestComplete from './views/PamphletRequestComplete'
import HTMLFragment from './HTMLFragment'

const Switch = () => {
    const location = useLocation()
    const intl = useIntl()

    const onBackButtonEvent = (e) => {
        e.preventDefault()
        if (window.confirm(intl.formatMessage({ id: 'browserBackButtonMsg' }))) {
            window.location.href = getExitPath()
        } else {
            window.history.pushState(null, null, window.location.pathname)
        }
    }

    useEffect(() => {
        adobeAnalyticsScriptAddition(location.pathname)
        cssAddition(location.pathname)
        loadSatelliteScript()
        // Scroll to top on page change
        if (typeof window !== 'undefined') {
            // Clearing Idle Timeout from Previous Page
            if (sessionUtils.get('idleTimeOut')) {
                clearTimeout(sessionUtils.get('idleTimeOut').data)
            }
            // Setting Timeout on Idle
            const timeOut = setTimeout(() => {
                window.location.href = getExitPath(location.pathname)
            }, IDLE_TIMEOUT * 60 * 1000)
            sessionUtils.set('idleTimeOut', timeOut)
        }
        window.scrollTo(0, 0)
        window.history.pushState(null, null, window.location.pathname + window.location.search)
        window.addEventListener('popstate', onBackButtonEvent)
        return () => {
            window.removeEventListener('popstate', onBackButtonEvent)
        }
    }, [location])

    return (
        <Routes location={location}>
            <Route exact path={`${CDP_PUBLIC_URL}/recruit`} element={<RequestForm />}></Route>
            <Route exact path={`${CDP_PUBLIC_URL}/recruit/confirm`} element={<RequestConfirm />}></Route>
            <Route exact path={`${CDP_PUBLIC_URL}/recruit/complete`} element={<CDPSuccess />}></Route>
            <Route exact path={`${CDP_PUBLIC_URL}/consulting`} element={<ConsultationServiceForm />}></Route>
            <Route exact path={`${CDP_PUBLIC_URL}/consulting/confirm`} element={<ConsultationServiceConfirm />}></Route>
            <Route exact path={`${CDP_PUBLIC_URL}/consulting/complete`} element={<ThankYouPage />}></Route>
            <Route exact path={`${CDP_PUBLIC_URL}/inquiry`} element={<ToiawasePage />}></Route>
            <Route exact path={`${CDP_PUBLIC_URL}/inquiry/confirm`} element={<ToiawaseConfirm />}></Route>
            <Route exact path={`${CDP_PUBLIC_URL}/inquiry/complete`} element={<ToiawaseThankYouPage />}></Route>
            <Route exact path={`${CDP_PUBLIC_URL}/agency`} element={<DairitenPage />}></Route>
            <Route exact path={`${CDP_PUBLIC_URL}/agency/confirm`} element={<DairitenConfirm />}></Route>
            <Route exact path={`${CDP_PUBLIC_URL}/agency/complete`} element={<DairitenThankYouPage />}></Route>
            <Route exact path={`${CDP_PUBLIC_URL}/pamphlet`} element={<PamphletForm />}></Route>
            <Route exact path={`${CDP_PUBLIC_URL}/pamphlet/confirm`} element={<PamphletConfirm />}></Route>
            <Route exact path={`${CDP_PUBLIC_URL}/pamphlet/complete`} element={<PamphletComplete />}></Route>
        </Routes>
    )
}

const RequestForm = () => {
    return (<>
        <React.Fragment>
            <HTMLFragment componentPath={'/forms/html/CDPHeader.htm'} />
            <FormContainer></FormContainer>
            <Footer></Footer>
        </React.Fragment>
    </>)
}

const RequestConfirm = () => {
    return (<>
        <React.Fragment>
            <HTMLFragment componentPath={'/forms/html/CDPHeader.htm'} />
            <ConfirmPage></ConfirmPage>
            <Footer></Footer>
        </React.Fragment>
    </>)
}

const CDPSuccess = () => {
    return (<>
        <React.Fragment>
            <HTMLFragment componentPath={'/forms/html/CDPHeader.htm'} />
            <SuccessPage></SuccessPage>
            <Footer></Footer>
        </React.Fragment>
    </>)
}

const ConsultationServiceForm = () => {
    return (<>
        <React.Fragment>
            <HTMLFragment componentPath={'/forms/html/FormHeader.htm'} />
            <ConsultationServiceForm1></ConsultationServiceForm1>
            <HTMLFragment componentPath={'/forms/html/SSLFooter.htm'} />
        </React.Fragment>
    </>)
}

const ConsultationServiceConfirm = () => {
    return (<>
        <React.Fragment>
            <HTMLFragment componentPath={'/forms/html/ConfirmHeader.htm'} />
            <ConsultationServiceConfirmPage></ConsultationServiceConfirmPage>
            <HTMLFragment componentPath={'/forms/html/SSLFooter.htm'} />
        </React.Fragment>
    </>)
}

const ThankYouPage = () => {
    return (<>
        <React.Fragment>
            <HTMLFragment componentPath={'/forms/html/CompleteHeader.htm'} />
            <ConsultationComplete></ConsultationComplete>
            <HTMLFragment componentPath={'/forms/html/SSLFooter.htm'} />
        </React.Fragment>
    </>)
}

const ToiawasePage = () => {
    return (<>
        <React.Fragment>
            <Header></Header>
            <ToiawaseFormPage></ToiawaseFormPage>
            <Footer></Footer>
        </React.Fragment>
    </>)
}

const ToiawaseConfirm = () => {
    return (<>
        <React.Fragment>
            <Header></Header>
            <ToiawaseFormConfirmPage />
            <Footer></Footer>
        </React.Fragment>
    </>)
}

const ToiawaseThankYouPage = () => {
    return (<>
        <React.Fragment>
            <Header></Header>
            <ToiawaseThankYou></ToiawaseThankYou>
            <Footer></Footer>
        </React.Fragment>
    </>)
}

const DairitenPage = () => {
    return (<>
        <React.Fragment>
            <Header></Header>
            <DairitenFormPage />
            <Footer></Footer>
        </React.Fragment>
    </>)
}

const DairitenConfirm = () => {
    return (<>
        <React.Fragment>
            <Header></Header>
            <DairitenConfirmPage />
            <Footer></Footer>
        </React.Fragment>
    </>)
}

const DairitenThankYouPage = () => {
    return (<>
        <React.Fragment>
            <Header></Header>
            <DairitenThankYou />
            <Footer></Footer>
        </React.Fragment>
    </>)
}

const PamphletForm = () => {
    return (<>
        <React.Fragment>
            <Header></Header>
            <PamphletRequestForm />
            <Footer></Footer>
        </React.Fragment>
    </>)
}

const PamphletConfirm = () => {
    return (<>
        <React.Fragment>
            <Header></Header>
            <PamphletRequestConfirm />
            <Footer></Footer>
        </React.Fragment>
    </>)
}

const PamphletComplete = () => {
    return (<>
        <React.Fragment>
            <Header></Header>
            <PamphletRequestComplete />
            <Footer></Footer>
        </React.Fragment>
    </>)
}

export default Switch
